<div class="search-by-size-selector" *ngIf="checkfitment && hasPricing()">
  <div class="staggered-wheel-selection">
    
    <!-- Front Wheels Section -->
    <div class="wheel-section">
      <h5 class="wheel-section-title">Front Wheels (Set of {{ frontQty }})</h5>
      
      <div class="wheel-selection-row">
        <div class="size-selector">
          <select 
            [(ngModel)]="frontWheelSize" 
            (change)="onSizeSelect($event, 'front')"
            class="form-control search-inputs search-inputs-bold">
            <option value="">Select Front Wheel Size</option>
            <option *ngFor="let wheel of availableWheels" [value]="wheel.id">
              {{ formatWheelOption(wheel) }}
            </option>
          </select>
        </div>
        
        <div class="quantity-controls">
          <button 
            type="button"
            class="btn btn-outline-secondary btn-sm qty-btn"
            (click)="adjustQuantity('front', -1)"
            [disabled]="frontQty <= 1">
            -
          </button>
          <input 
            [(ngModel)]="frontQty" 
            type="number" 
            class="form-control qty-input"
            min="1" 
            max="4"
            readonly>
          <button 
            type="button"
            class="btn btn-outline-secondary btn-sm qty-btn"
            (click)="adjustQuantity('front', 1)"
            [disabled]="frontQty >= 4">
            +
          </button>
        </div>
        
        <div class="price-display">
          <span class="price-value">${{ getEffectivePrice('front') | number:'1.2-2' }}</span>
          <span class="price-label" *ngIf="showFrontSale">(Sale Price)</span>
        </div>
      </div>
    </div>
    
    <!-- Rear Wheels Section (only if product has rear specifications) -->
    <div class="wheel-section" *ngIf="hasRearWheels">
      <h5 class="wheel-section-title">Rear Wheels (Set of {{ rearQty }})</h5>
      
      <div class="wheel-selection-row">
        <div class="size-selector">
          <select 
            [(ngModel)]="rearWheelSize" 
            (change)="onSizeSelect($event, 'rear')"
            class="form-control search-inputs search-inputs-bold">
            <option value="">Select Rear Wheel Size</option>
            <option *ngFor="let wheel of availableWheels" [value]="wheel.id">
              {{ formatWheelOption(wheel) }}
            </option>
          </select>
        </div>
        
        <div class="quantity-controls">
          <button 
            type="button"
            class="btn btn-outline-secondary btn-sm qty-btn"
            (click)="adjustQuantity('rear', -1)"
            [disabled]="rearQty <= 1">
            -
          </button>
          <input 
            [(ngModel)]="rearQty" 
            type="number" 
            class="form-control qty-input"
            min="1" 
            max="4"
            readonly>
          <button 
            type="button"
            class="btn btn-outline-secondary btn-sm qty-btn"
            (click)="adjustQuantity('rear', 1)"
            [disabled]="rearQty >= 4">
            +
          </button>
        </div>
        
        <div class="price-display">
          <span class="price-value">${{ getEffectivePrice('rear') | number:'1.2-2' }}</span>
          <span class="price-label" *ngIf="showRearSale">(Sale Price)</span>
        </div>
      </div>
    </div>
    
    <!-- Total Price Section -->
    <div class="total-section" *ngIf="totalPrice > 0">
      <div class="total-price-display">
        <h4 class="total-label">Total: <span class="total-value">${{ totalPrice | number:'1.2-2' }}</span></h4>
        <small class="total-description">
          {{ hasRearWheels ? 'Complete staggered set' : 'Set of ' + (frontQty * 2) + ' wheels' }}
        </small>
      </div>
    </div>
    
  </div>
</div>

<!-- No fitment or pricing message -->
<div *ngIf="!checkfitment || !hasPricing()" class="no-selection-message">
  <p class="text-muted">
    <span *ngIf="!checkfitment">Please check fitment to select wheel sizes.</span>
    <span *ngIf="checkfitment && !hasPricing()">Pricing information not available.</span>
  </p>
</div>
